import { Messages } from '~src/codegen/Localize';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { ISetContactAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { IFavoritableItemInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { CardResizerService } from '~src/spacesPlatform/services/CardResizerService';

import { SourceComponentType } from '../ActionsMenu';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const AddFavoriteAction: IEntityAction<IContentInfo, {}> = {
    name: EntityActionNames.AddFavorite,
    translateName: Messages.addToFavorites,
    isVisible: (items, state, availableActions, sourceComponent: SourceComponentType) => {
        return sourceComponent === 'Card' ? CardResizerService.instance.shouldUseCompactCardTitle() && items.length === 1 && !items[0].favorite : false;
    },
    isClickable: (availableActions: ISetContactAction) => true,
    createReduxAction: (items: IContentInfo[]) => {
        if (!items || items.length === 0 || items.length > 1) {
            throw new Error('AddFavoriteAction was called without exactly one item');
        }

        return addContentFavorite(items[0] as IFavoritableItemInfo);
    }
};

export const RemoveFavoriteAction: IEntityAction<IContentInfo, {}> = {
    name: EntityActionNames.RemoveFavorite,
    translateName: Messages.removeFromFavorites,
    isVisible: (items, state, availableActions, sourceComponent: SourceComponentType) => {
        return sourceComponent === 'Card' ? CardResizerService.instance.shouldUseCompactCardTitle() && items.length === 1 && items[0].favorite : false;
    },
    isClickable: (availableActions: ISetContactAction) => true,
    createReduxAction: (items: IContentInfo[]) => {
        if (!items || items.length === 0 || items.length > 1) {
            throw new Error('RemoveFavoriteAction was called without exactly one item');
        }

        return removeContentFavorite(items[0] as IFavoritableItemInfo);
    }
};